import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const CampbellfieldEmergencyDentistPage = () => (
  <ServiceLocationTemplate suburbName="Campbellfield" suburbSlug="campbellfield" variant="emergency-dentist" />
);

export default CampbellfieldEmergencyDentistPage;
